import { ReplyButton } from '@lumapps/reactions-comments/components/CommentBlock/ReplyButton';
import { CommentButton } from '@lumapps/reactions-comments/components/CommentButton';
import { ReactButton } from '@lumapps/reactions-react/components/ReactButton';
import { VoteButton } from '@lumapps/reactions-votes/components/VoteButton';

import { ReactionsBlock } from '../ReactionsBlock';

const SUB_COMPONENTS = {
    React: ReactButton,
    Comment: CommentButton,
    CommentReply: ReplyButton,
    Vote: VoteButton,
};

export const Reactions = Object.assign(ReactionsBlock, SUB_COMPONENTS);
